import axios from "axios";
import {
  //
  ROLE_REQUEST,
  ROLE_SUCCESS,
  ROLE_FAIL,
  ROLE_CLEAR_ERRORS,
  //
  COMPANY_REQUEST,
  COMPANY_SUCCESS,
  COMPANY_FAIL,
  COMPANY_CLEAR_ERRORS,
  //
  MARKET_SHARE_REQUEST,
  MARKET_SHARE_SUCCESS,
  MARKET_SHARE_FAIL,
  MARKET_SHARE_CLEAR_ERRORS,
  //
  INDUSTRY_REQUEST,
  INDUSTRY_SUCCESS,
  INDUSTRY_FAIL,
  INDUSTRY_CLEAR_ERRORS,
  //
  ANNUAL_REVENUE_REQUEST,
  ANNUAL_REVENUE_SUCCESS,
  ANNUAL_REVENUE_FAIL,
  ANNUAL_REVENUE_CLEAR_ERRORS,
  //
  TOTAL_HEAD_COUNT_REQUEST,
  TOTAL_HEAD_COUNT_SUCCESS,
  TOTAL_HEAD_COUNT_FAIL,
  TOTAL_HEAD_COUNT_CLEAR_ERRORS,
} from "../Constants/company_constants";

// role
export const get_roles = () => async (dispatch) => {
  try {
    dispatch({
      type: ROLE_REQUEST,
    });
    const role = await axios.get(`${process.env.REACT_APP_API_URL}/api/role/`);

    dispatch({
      type: ROLE_SUCCESS,
      payload: role,
    });
  } catch (error) {
    dispatch({
      type: ROLE_FAIL,
      payload: error.response,
    });
  }
};
export const add_roles = (role_payload) => async (dispatch) => {
  try {
    dispatch({
      type: ROLE_REQUEST,
    });
    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/role/`,
      role_payload
    );
    const role = await axios.get(`${process.env.REACT_APP_API_URL}/api/role/`);

    dispatch({
      type: ROLE_SUCCESS,
      payload: role,
    });
  } catch (error) {
    dispatch({
      type: ROLE_FAIL,
      payload: error.response,
    });
  }
};
export const update_roles = (role_payload, id) => async (dispatch) => {
  try {
    dispatch({
      type: ROLE_REQUEST,
    });
    await axios.put(
      `${process.env.REACT_APP_API_URL}/api/role/${id}`,
      role_payload
    );

    const role = await axios.get(`${process.env.REACT_APP_API_URL}/api/role/`);

    dispatch({
      type: ROLE_SUCCESS,
      payload: role,
    });
  } catch (error) {
    dispatch({
      type: ROLE_FAIL,
      payload: error.response,
    });
  }
};
export const delete_roles = (id) => async (dispatch) => {
  try {
    dispatch({
      type: ROLE_REQUEST,
    });
    await axios.delete(`${process.env.REACT_APP_API_URL}/survey/survey/${id}/`);
    const role = await axios.get(`${process.env.REACT_APP_API_URL}/api/role/`);

    dispatch({
      type: ROLE_SUCCESS,
      payload: role,
    });
  } catch (error) {
    dispatch({
      type: ROLE_FAIL,
      payload: error.response,
    });
  }
};
export const role_clearErrors = () => async (dispatch) => {
  dispatch({
    type: ROLE_CLEAR_ERRORS,
  });
};

// company request
export const get_company = () => async (dispatch) => {
  try {
    dispatch({
      type: COMPANY_REQUEST,
    });
    const company = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/companytype/`
    );

    dispatch({
      type: COMPANY_SUCCESS,
      payload: company,
    });
  } catch (error) {
    dispatch({
      type: COMPANY_FAIL,
      payload: error.response,
    });
  }
};
export const add_company = (company_payload) => async (dispatch) => {
  try {
    dispatch({
      type: COMPANY_REQUEST,
    });
    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/companytype/`,
      company_payload
    );
    const company = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/companytype/`
    );

    dispatch({
      type: COMPANY_SUCCESS,
      payload: company,
    });
  } catch (error) {
    dispatch({
      type: COMPANY_FAIL,
      payload: error.response,
    });
  }
};
export const update_company = (company_payload, id) => async (dispatch) => {
  try {
    dispatch({
      type: COMPANY_REQUEST,
    });
    await axios.put(
      `${process.env.REACT_APP_API_URL}/api/companytype/${id}/`,
      company_payload
    );

    const company = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/companytype/`
    );

    dispatch({
      type: COMPANY_SUCCESS,
      payload: company,
    });
  } catch (error) {
    dispatch({
      type: COMPANY_FAIL,
      payload: error.response,
    });
  }
};
export const delete_company = (id) => async (dispatch) => {
  try {
    dispatch({
      type: COMPANY_REQUEST,
    });
    await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/companytype/${id}/`
    );
    const company = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/companytype/`
    );

    dispatch({
      type: COMPANY_SUCCESS,
      payload: company,
    });
  } catch (error) {
    dispatch({
      type: COMPANY_FAIL,
      payload: error.response,
    });
  }
};
export const company_clearErrors = () => async (dispatch) => {
  dispatch({
    type: COMPANY_CLEAR_ERRORS,
  });
};

//market share request
export const get_market_share = () => async (dispatch) => {
  try {
    dispatch({
      type: MARKET_SHARE_REQUEST,
    });
    const market_share = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/marketshare/`
    );

    dispatch({
      type: MARKET_SHARE_SUCCESS,
      payload: market_share,
    });
  } catch (error) {
    dispatch({
      type: MARKET_SHARE_FAIL,
      payload: error.response,
    });
  }
};
export const add_market_share = (market_share_payload) => async (dispatch) => {
  try {
    dispatch({
      type: MARKET_SHARE_REQUEST,
    });
    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/marketshare/`,
      market_share_payload
    );
    const market_share = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/marketshare/`
    );

    dispatch({
      type: MARKET_SHARE_SUCCESS,
      payload: market_share,
    });
  } catch (error) {
    dispatch({
      type: MARKET_SHARE_FAIL,
      payload: error.response,
    });
  }
};
export const update_market_share =
  (market_share_payload, id) => async (dispatch) => {
    try {
      dispatch({
        type: MARKET_SHARE_REQUEST,
      });
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/marketshare/${id}/`,
        market_share_payload
      );
      const market_share = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/marketshare/`
      );

      dispatch({
        type: MARKET_SHARE_SUCCESS,
        payload: market_share,
      });
    } catch (error) {
      dispatch({
        type: MARKET_SHARE_FAIL,
        payload: error.response,
      });
    }
  };
export const delete_market_share = (id) => async (dispatch) => {
  try {
    dispatch({
      type: MARKET_SHARE_REQUEST,
    });
    await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/marketshare/${id}/`
    );
    const market_share = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/marketshare/`
    );

    dispatch({
      type: MARKET_SHARE_SUCCESS,
      payload: market_share,
    });
  } catch (error) {
    dispatch({
      type: MARKET_SHARE_FAIL,
      payload: error.response,
    });
  }
};
export const market_share_clearErrors = () => async (dispatch) => {
  dispatch({
    type: MARKET_SHARE_CLEAR_ERRORS,
  });
};
// Industry request

export const get_industry = () => async (dispatch) => {
  try {
    dispatch({
      type: INDUSTRY_REQUEST,
    });
    const industry = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/industry/`
    );

    dispatch({
      type: INDUSTRY_SUCCESS,
      payload: industry,
    });
  } catch (error) {
    dispatch({
      type: INDUSTRY_FAIL,
      payload: error.response,
    });
  }
};
export const add_industry = (industry_payload) => async (dispatch) => {
  try {
    dispatch({
      type: INDUSTRY_REQUEST,
    });
    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/industry/`,
      industry_payload
    );
    const industry = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/industry/`
    );

    dispatch({
      type: INDUSTRY_SUCCESS,
      payload: industry,
    });
  } catch (error) {
    dispatch({
      type: INDUSTRY_FAIL,
      payload: error.response,
    });
  }
};
export const update_industry = (industry_payload, id) => async (dispatch) => {
  try {
    dispatch({
      type: INDUSTRY_REQUEST,
    });
    await axios.put(
      `${process.env.REACT_APP_API_URL}/api/industry/${id}/`,
      industry_payload
    );
    const industry = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/industry/`
    );

    dispatch({
      type: INDUSTRY_SUCCESS,
      payload: industry,
    });
  } catch (error) {
    dispatch({
      type: INDUSTRY_FAIL,
      payload: error.response,
    });
  }
};
export const delete_industry = (id) => async (dispatch) => {
  try {
    dispatch({
      type: INDUSTRY_REQUEST,
    });
    await axios.delete(`${process.env.REACT_APP_API_URL}/api/industry/${id}/`);
    const industry = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/industry/`
    );

    dispatch({
      type: INDUSTRY_SUCCESS,
      payload: industry,
    });
  } catch (error) {
    dispatch({
      type: INDUSTRY_FAIL,
      payload: error.response,
    });
  }
};
export const industry_clearErrors = () => async (dispatch) => {
  dispatch({
    type: INDUSTRY_CLEAR_ERRORS,
  });
};

// annual revenue request

export const get_annual_revenue = () => async (dispatch) => {
  try {
    dispatch({
      type: ANNUAL_REVENUE_REQUEST,
    });
    const annualrevenue = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/annualrevenue/`
    );

    dispatch({
      type: ANNUAL_REVENUE_SUCCESS,
      payload: annualrevenue,
    });
  } catch (error) {
    dispatch({
      type: ANNUAL_REVENUE_FAIL,
      payload: error.response,
    });
  }
};
export const add_annual_revenue =
  (annualrevenue_payload) => async (dispatch) => {
    try {
      dispatch({
        type: ANNUAL_REVENUE_REQUEST,
      });
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/annualrevenue/`,
        annualrevenue_payload
      );
      const annualrevenue = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/annualrevenue/`
      );

      dispatch({
        type: ANNUAL_REVENUE_SUCCESS,
        payload: annualrevenue,
      });
    } catch (error) {
      dispatch({
        type: ANNUAL_REVENUE_FAIL,
        payload: error.response,
      });
    }
  };
export const update_annual_revenue =
  (annualrevenue_payload, id) => async (dispatch) => {
    try {
      dispatch({
        type: ANNUAL_REVENUE_REQUEST,
      });
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/annualrevenue/${id}/`,
        annualrevenue_payload
      );
      const annualrevenue = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/annualrevenue/`
      );

      dispatch({
        type: ANNUAL_REVENUE_SUCCESS,
        payload: annualrevenue,
      });
    } catch (error) {
      dispatch({
        type: ANNUAL_REVENUE_FAIL,
        payload: error.response,
      });
    }
  };
export const delete_annual_revenue = (id) => async (dispatch) => {
  try {
    dispatch({
      type: ANNUAL_REVENUE_REQUEST,
    });
    await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/annualrevenue/${id}/`
    );
    const annualrevenue = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/annualrevenue/`
    );

    dispatch({
      type: ANNUAL_REVENUE_SUCCESS,
      payload: annualrevenue,
    });
  } catch (error) {
    dispatch({
      type: ANNUAL_REVENUE_FAIL,
      payload: error.response,
    });
  }
};
export const annual_revenue_clearErrors = () => async (dispatch) => {
  dispatch({
    type: ANNUAL_REVENUE_CLEAR_ERRORS,
  });
};

// total head count request
export const get_total_headcount = () => async (dispatch) => {
  try {
    dispatch({
      type: TOTAL_HEAD_COUNT_REQUEST,
    });
    const totalheadcount = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/totalheadcount/`
    );

    dispatch({
      type: TOTAL_HEAD_COUNT_SUCCESS,
      payload: totalheadcount,
    });
  } catch (error) {
    dispatch({
      type: TOTAL_HEAD_COUNT_FAIL,
      payload: error.response,
    });
  }
};
export const add_total_headcount =
  (totalheadcount_payload) => async (dispatch) => {
    try {
      dispatch({
        type: TOTAL_HEAD_COUNT_REQUEST,
      });
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/totalheadcount/`,
        totalheadcount_payload
      );
      const totalheadcount = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/totalheadcount/`
      );

      dispatch({
        type: TOTAL_HEAD_COUNT_SUCCESS,
        payload: totalheadcount,
      });
    } catch (error) {
      dispatch({
        type: TOTAL_HEAD_COUNT_FAIL,
        payload: error.response,
      });
    }
  };
export const update_total_headcount =
  (totalheadcount_payload, id) => async (dispatch) => {
    try {
      dispatch({
        type: TOTAL_HEAD_COUNT_REQUEST,
      });
      await axios.put(
        `${process.env.REACT_APP_API_URL}/api/totalheadcount/${id}/`,
        totalheadcount_payload
      );
      const totalheadcount = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/totalheadcount/`
      );

      dispatch({
        type: TOTAL_HEAD_COUNT_SUCCESS,
        payload: totalheadcount,
      });
    } catch (error) {
      dispatch({
        type: TOTAL_HEAD_COUNT_FAIL,
        payload: error.response,
      });
    }
  };
export const delete_total_headcount = (id) => async (dispatch) => {
  try {
    dispatch({
      type: TOTAL_HEAD_COUNT_REQUEST,
    });
    await axios.delete(
      `${process.env.REACT_APP_API_URL}/api/totalheadcount/${id}/`
    );
    const totalheadcount = await axios.get(
      `${process.env.REACT_APP_API_URL}/api/totalheadcount/`
    );

    dispatch({
      type: TOTAL_HEAD_COUNT_SUCCESS,
      payload: totalheadcount,
    });
  } catch (error) {
    dispatch({
      type: TOTAL_HEAD_COUNT_FAIL,
      payload: error.response,
    });
  }
};
export const total_headcount_clearErrors = () => async (dispatch) => {
  dispatch({
    type: TOTAL_HEAD_COUNT_CLEAR_ERRORS,
  });
};
